import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSessionContext } from '@/context/SessionContextProvider';
import { getGuardForRoute, isRouteCompatibleWithContext } from '@/utils/contextHelper';
import { StoreSelectionDialog } from './StoreSelectionDialog';

/**
 * Componente que monitora mudanças de rota e verifica compatibilidade com o contexto.
 * Se houver incompatibilidade, mostra dialog para o usuário corrigir.
 */
export const ContextRouteGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { networkId, storeId, isInitialized } = useSessionContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [requiredContext, setRequiredContext] = useState<string>('');

  useEffect(() => {
    // Só validar após contexto inicializado
    if (!isInitialized) return;

    const path = location.pathname;
    
    // Ignorar rotas especiais
    if (path.startsWith('/login') || 
         
        path.startsWith('/super-admin') ||
        path.startsWith('/portal-corretor') ||
         path.startsWith('/cadastro-corretor') ||
         path.startsWith('/corretor/primeiro-acesso') ||
        path.startsWith('/escolher-ambiente') ||
        path.startsWith('/site-publico') ||
        path.startsWith('/instalar')) {
      return;
    }

    const guardType = getGuardForRoute(path);
    const compatibility = isRouteCompatibleWithContext(
      path,
      !!networkId,
      !!storeId
    );

    console.log('🛡️ ContextRouteGuard:', {
      path,
      guardType,
      compatibility,
      networkId,
      storeId
    });

    // Se não for compatível, mostrar dialog
    if (!compatibility.compatible) {
      console.log('⚠️ Contexto incompatível:', compatibility.reason);
      
      if (guardType === 'STORE_REQUIRED' && !storeId) {
        setRequiredContext('STORE_REQUIRED');
        setDialogOpen(true);
      } else if (guardType === 'NETWORK_REQUIRED' && storeId) {
        // Poderia mostrar um toast ou redirecionar
        console.log('ℹ️ Página requer modo rede, mas usuário está em modo loja');
      }
    }
  }, [location.pathname, networkId, storeId, isInitialized]);

  const handleClose = () => {
    setDialogOpen(false);
    // Voltar para a página anterior ou página inicial
    navigate(-1);
  };

  const handleStoreSelected = () => {
    setDialogOpen(false);
    // O usuário já foi redirecionado pelo switchToStoreMode
  };

  return (
    <StoreSelectionDialog
      open={dialogOpen}
      onClose={handleClose}
      onStoreSelected={handleStoreSelected}
      requiredContext={requiredContext}
    />
  );
};
